import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['unlimited', 'capField', 'cap']

  toggle() {
    const unlimited = this.unlimitedTarget.checked
    this.capFieldTarget.classList.toggle('hidden', unlimited)
    if (this.hasCapTarget) {
      this.capTarget.disabled = unlimited
      if (unlimited) this.capTarget.removeAttribute('name')
      else this.capTarget.setAttribute('name', 'pipeline[messages_per_day]')
    }
  }
}
